<template>
  <div class="meetingsGoogleDocStep">
    <vx-card class="h-full">
      <template v-if="meetingInstance.googleDocumentUrl">
        <vs-row vs-justify="flex-end" class="mb-2">
          <GoogleDocActions :url="meetingInstance.googleDocumentUrl" @fullscreen="fullscreenDoc" />
        </vs-row>
        <iframe ref="docFrame" :src="meetingInstance.googleDocumentUrl" class="googleDocFrame" frameborder="0" />
      </template>
      <div v-else class="noDocument flex justify-center items-center text-center">
        No Google Doc or Sheet is attached to this meeting.
      </div>
    </vx-card>
  </div>
</template>

<script>
import GoogleDocActions from "./GoogleDocActions.vue";

export default {
  props: ["step", "meetingInstance"],
  components: { GoogleDocActions },
  methods: {
    fullscreenDoc() {
      const frame = this.$refs.docFrame;
      if (!frame) return;
      if (document.fullscreenElement) document.exitFullscreen();
      else frame.requestFullscreen();
    }
  }
};
</script>

<style lang="scss">
.meetingsGoogleDocStep {
  .googleDocFrame {
    width: 100%;
    height: 70vh;
    border: 0;
  }

  .noDocument {
    min-height: 200px;
  }

  // Same height as the document next to Power BI, so Back/Next stay on screen
  @media (min-height: 900px) {
    .googleDocFrame {
      height: calc(100vh - 330px);
    }
  }
}
</style>
